/**
 * 存储localStorage
 */
function setLocal(name, content) {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}
/**
 * 获取localStorage
 */
function getLocal(name) {
  if (!name) return
  return window.localStorage.getItem(name)
}

/**
 * 删除localStorage
 */
function removeLocal(name) {
  if (!name) return
  window.localStorage.removeItem(name)
}
/**
 * 存储sessionStorage
 */
function setSession(name, content) {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.sessionStorage.setItem(name, content)
}
/**
 * 获取sessionStorage
 */
function getSession(name) {
  if (!name) return
  return window.sessionStorage.getItem(name)
}
/**
 * 删除sessionStorage
 */
function removeSession(name) {
  if (!name) return
  window.sessionStorage.removeItem(name)
}
/**
 * 存储Cookie
 */
function setCookie(name, content) {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  // console.log(content, 'content')
  document.cookie = name + '=' + escape(content) + '; path=/'
}
/**
 * 获取Cookie
 */
function getCookie(name) {
  var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  var arr = document.cookie.match(reg)
  if (arr) return unescape(arr[2])
  else return null
}
/**
 * 删除Cookie
 */
function removeCookie(name) {
  var exp = new Date()
  exp.setTime(exp.getTime() - 1)
  var cval = getCookie(name)
  if (cval != null) document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString() + '; path=/'
}
export default {
  setLocal,
  getLocal,
  removeLocal,
  setSession,
  getSession,
  removeSession,
  setCookie,
  getCookie,
  removeCookie
}
